import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "dropbox",
  "name": "Dropbox",
  "category": "integrations",
  "description": "Upload and manage files in Dropbox",
  "icon": "siDropbox",
  "iconType": "simple-icon",
  "color": "blue",
  "version": "1.3.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Dropbox",
    "color": "#0061ff"
  },
  "credentials": [
    {
      "name": "dropboxOAuth2",
      "required": true,
      "displayName": "Dropbox OAuth2"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "dropbox",
    "storage",
    "files",
    "cloud",
    "sync"
  ],
  "comingSoon": true
};

export default definition;
